import { render } from "./App.vue?vue&type=template&id=74bf33d6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=74bf33d6&lang=css"

import exportComponent from "E:\\软件项目\\神木市官网界面\\shenmu-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__